import auth from '@/router/auth'
import PromotionIndex from '@/components/class-users-v2/Index'
import PromotionCreate from '@/components/class-users-v2/Create'
import PromotionUpdate from '@/components/class-users-v2/Update'
import PromotionShow from '@/components/class-users-v2/Show'
import PromotionShowScore from '@/components/class-users-v2/ShowScore'

export default [
  {
    path: '/class-users-v2',
    name: 'class-users-v2-index',
    component: PromotionIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-users-v2/create',
    name: 'class-users-v2-create',
    component: PromotionCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-users-v2/update/:id',
    name: 'class-users-v2-update',
    component: PromotionUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-users-v2/show/:id',
    name: 'class-users-v2-show',
    component: PromotionShow,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-users-v2/show-score/:id',
    name: 'class-users-v2-show-score',
    component: PromotionShowScore,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/class-users-v2/router.js